'use strict';
import {runInjector} from '../_libs/angular-utils/index';
import {OrgCalendar} from './components/OrgCalendar';
import {OrgCalendarComponent} from './components/OrgCalendar/OrgCalendarComponent';
import {routerConfig} from './router';

/**
 * Module dependencies
 */
const angular = require('angular');

module.exports = angular
  .module('app.calendar', [])
  .value('OrgCalendarView', OrgCalendar)
  .run(runInjector(OrgCalendarComponent))
  .config(routerConfig)

  .provider('$$AbstractEvent', require('./domain/$$AbstractEvent.js'))
  .provider('CalendarEventDomain', require('./domain/CalendarEventDomain.js'))

  .service('assignmentStatusService', require('./AssignmentStatusService.js'))

  .directive('timeFormat', require('./TimeFormatDirective.js'))
;



// WEBPACK FOOTER //
// ./src/js/calendar/index.js